import React from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { withViewport } from '../../util/contextHelpers';

import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
  ExternalLink,
  NamedLink,
  ContactPreFooter,
} from '../../components';
import heroImage from '../../assets/piirla-success-story-banner.webp';

import { TopbarContainer } from '..';
import { FormattedMessage } from '../../util/reactIntl';

import css from './SuccessStoryPiirlaPage.css';

export const SuccessStoryPiirlaPageComponent = props => {
  const { intl, scrollingDisabled, viewport } = props;

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const schemaTitle = intl.formatMessage({ id: 'SuccessStoryPiirla.schemaTitle' });
  const schemaDescription = intl.formatMessage({
    id: 'SuccessStoryPiirla.schemaDescription',
  });

  const handleShowSpaceHome = () => {
    if (typeof window === 'object') {
      window.Intercom('showSpace', 'home');
    }
  };

  const MAX_MOBILE_SCREEN_WIDTH = 962;

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="SuccessStoryPiirlaPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.heroSection}>
            <div className={css.heroSectionLeft}>
              <div className={css.heroSectionBreadcrumbs}>
                <NamedLink name="SuccessStoriesPage">
                  <FormattedMessage id="SuccessStoryPiirla.heroBreadcrumbs1" />
                </NamedLink>
                <FormattedMessage id="SuccessStoryPiirla.heroBreadcrumbs2" />
                <FormattedMessage id="SuccessStoryPiirla.heroBreadcrumbs3" />
              </div>
              {viewport.width <= MAX_MOBILE_SCREEN_WIDTH ? (
                <div className={css.heroSectionMobile}>
                  <img
                    src={heroImage}
                    alt="Hero"
                    className={css.proInfoSectionContentImage}
                    loading="lazy"
                  />
                </div>
              ) : null}
              <div className={css.heroSectionTitle}>
                <FormattedMessage id="SuccessStoryPiirla.heroTitle" />
              </div>
              <div className={css.heroSectionText}>
                <FormattedMessage id="SuccessStoryPiirla.heroText" />
              </div>
              <div className={css.heroSectionTags}>
                <div className={css.heroSectionTag}>
                  <FormattedMessage id="SuccessStoryPiirla.heroTag1" />
                </div>

                <div className={css.heroSectionTag}>
                  <FormattedMessage id="SuccessStoryPiirla.heroTag2" />
                </div>
              </div>
            </div>
            {viewport.width > MAX_MOBILE_SCREEN_WIDTH ? (
              <div className={css.heroSectionRight}>
                <img
                  src={heroImage}
                  alt="Hero"
                  className={css.proInfoSectionContentImage}
                  loading="lazy"
                />
              </div>
            ) : null}
          </div>
          <div className={css.sections}>
            <div className={css.contentSection}>
              <div className={css.contentSectionContent}>
                <div>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionTitle1" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage
                        id="SuccessStoryPiirla.contentSectionParagraph11"
                        values={{
                          a: chunks => (
                            <a
                              href="https://piirla.fi/"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: '#1683A3', fontWeight: 600 }}
                            >
                              {chunks}
                            </a>
                          ),
                        }}
                      />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage
                        id="SuccessStoryPiirla.contentSectionParagraph12"
                        values={{
                          a: chunks => (
                            <NamedLink
                              name="ArticlesAndBlogContent"
                              style={{ color: '#1683A3', fontWeight: 600 }}
                            >
                              {chunks}
                            </NamedLink>
                          ),
                        }}
                      />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage
                        id="SuccessStoryPiirla.contentSectionParagraph13"
                        values={{
                          b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
                        }}
                      />
                    </p>
                    <div className={css.articleBlockWithBG}>
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionParagraph14" />
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionParagraph14Name" />
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionParagraph14Company" />
                    </div>
                  </article>
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionTitle2" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionParagraph21" />
                    </p>
                    <p className={css.contentSectionH2}>
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionHeading21" />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionParagraph22" />
                    </p>
                    <p className={css.contentSectionTextBold}>
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionParagraph23" />
                    </p>
                    <p className={css.contentSectionH2}>
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionHeading22" />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionParagraph24" />
                    </p>
                    <div className={css.articleBlockWithBG}>
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionParagraph24Quote" />
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionParagraph24Name" />
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionParagraph24Company" />
                    </div>
                    <p className={css.contentSectionH2}>
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionHeading23" />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionParagraph25" />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionParagraph26" />
                    </p>
                    <p className={css.contentSectionTextBold}>
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionParagraph27" />
                    </p>
                  </article>
                  {viewport.width <= MAX_MOBILE_SCREEN_WIDTH ? (
                    <div className={css.contentSectionCTAmobile}>
                      <div className={css.contentSectionCTAtitle}>
                        <FormattedMessage id="SuccessStoryZervant.CTAtitle" />
                      </div>
                      <div className={css.contentSectionCTAtext}>
                        <FormattedMessage id="SuccessStoryZervant.CTAtext" />
                      </div>
                      <div className={css.contentSectionCTAbutton}>
                        <ExternalLink
                          className={css.contentSectionContactButton}
                          onClick={handleShowSpaceHome}
                        >
                          <FormattedMessage id="SuccessStoryZervant.CTAbuttonText" />
                        </ExternalLink>
                      </div>
                    </div>
                  ) : null}
                  <header>
                    <h2 className={css.contentSectionTitle}>
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionTitle3" />
                    </h2>
                  </header>
                  <article>
                    <p className={css.contentSectionText}>
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionParagraph31" />
                    </p>
                    <p className={css.contentSectionText}>
                      <FormattedMessage
                        id="SuccessStoryPiirla.contentSectionParagraph32"
                        values={{
                          b: chunks => <strong style={{ fontWeight: 600 }}>{chunks}</strong>,
                        }}
                      />
                    </p>
                  </article>
                  <div className={css.articleSectionResults}>
                    <div className={css.articleSectionResultsTitle}>
                      <FormattedMessage id="SuccessStoryPiirla.contentSectionResultsTitle" />
                    </div>
                    <ul className={css.articleSectionResultsList}>
                      <li className={css.articleSectionResultsListItem}>
                        <FormattedMessage id="SuccessStoryPiirla.contentSectionResultsListItem1" />
                      </li>
                      <li className={css.articleSectionResultsListItem}>
                        <FormattedMessage id="SuccessStoryPiirla.contentSectionResultsListItem2" />
                      </li>
                      <li className={css.articleSectionResultsListItem}>
                        <FormattedMessage id="SuccessStoryPiirla.contentSectionResultsListItem3" />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {viewport.width > MAX_MOBILE_SCREEN_WIDTH ? (
                <div className={css.contentSectionCTAbar}>
                  <div className={css.contentSectionCTA}>
                    <div className={css.contentSectionCTAtitle}>
                      <FormattedMessage id="SuccessStoryZervant.CTAtitle" />
                    </div>
                    <div className={css.contentSectionCTAtext}>
                      <FormattedMessage id="SuccessStoryZervant.CTAtext" />
                    </div>
                    <div className={css.contentSectionCTAbutton}>
                      <ExternalLink
                        className={css.contentSectionContactButton}
                        onClick={handleShowSpaceHome}
                      >
                        <FormattedMessage id="SuccessStoryZervant.CTAbuttonText" />
                      </ExternalLink>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            <ContactPreFooter />
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

SuccessStoryPiirlaPageComponent.defaultProps = {
  scrollingDisabled: false,
};

const { number, shape } = PropTypes;

SuccessStoryPiirlaPageComponent.propTypes = {
  // form withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired, // from injectIntl
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const SuccessStoryPiirlaPage = compose(
  withRouter,
  connect(mapStateToProps),
  withViewport,
  injectIntl
)(SuccessStoryPiirlaPageComponent);

export default SuccessStoryPiirlaPage;
